import axiosLimiter from '@/api/RateLimiter';

export default {
  // User Permissions Management
  getAllUserPermissions(tenantId: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/user-permissions'
    );
  },

  getUserPermissions(tenantId: string, userId: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/user-permissions/' +
        userId
    );
  },

  createUserPermissions(
    tenantId: string,
    userId: string,
    dashboardCreate: boolean,
    dashboardShare: boolean,
    propertyFavorites: boolean,
    staging: boolean,
    canvasWrite: boolean
  ): Promise<any> {
    const body = {
      userId,
      dashboardCreate,
      dashboardShare,
      propertyFavorites,
      staging,
      canvasWrite,
    };

    return axiosLimiter.post(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/user-permissions',
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },

  updateUserPermissions(
    tenantId: string,
    userId: string,
    permissions: Partial<{
      dashboardCreate: boolean;
      dashboardShare: boolean;
      propertyFavorites: boolean;
      staging: boolean;
      canvasWrite: boolean;
    }>
  ): Promise<any> {
    return axiosLimiter.put(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/user-permissions/' +
        userId,
      JSON.stringify(permissions),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },

  deleteUserPermissions(tenantId: string, userId: string): Promise<any> {
    return axiosLimiter.delete(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/user-permissions/' +
        userId
    );
  },

  // Tenant Default Permissions Management
  getTenantDefaultPermissions(tenantId: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/tenant-default-permissions'
    );
  },

  createTenantDefaultPermissions(
    tenantId: string,
    dashboardCreate: boolean,
    dashboardShare: boolean,
    propertyFavorites: boolean,
    staging: boolean,
    canvasWrite: boolean
  ): Promise<any> {
    const body = {
      dashboardCreate,
      dashboardShare,
      propertyFavorites,
      staging,
      canvasWrite,
    };

    return axiosLimiter.post(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/tenant-default-permissions',
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },

  updateTenantDefaultPermissions(
    tenantId: string,
    permissions: Partial<{
      dashboardCreate: boolean;
      dashboardShare: boolean;
      propertyFavorites: boolean;
      staging: boolean;
      canvasWrite: boolean;
    }>
  ): Promise<any> {
    return axiosLimiter.put(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/tenant-default-permissions',
      JSON.stringify(permissions),
      { headers: { 'Content-Type': 'application/json' } }
    );
  },

  deleteTenantDefaultPermissions(tenantId: string): Promise<any> {
    return axiosLimiter.delete(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/admin/tenant-default-permissions'
    );
  },

  getOwnUserPermissions(tenantId: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_APP_PORTAL_SERVER_URL +
        '/' +
        tenantId +
        '/permissions'
    );
  },
};
